<template>
  <el-form-item :label="i18nt('designer.setting.placeholder')">
    <el-input type="text" v-model="optionModel.placeholder"></el-input>
  </el-form-item>
</template>

<script>
  import i18n from "../../../../utils/i18n"
  import propertyMixin from "../../setting-panel/property-editor/propertyMixin"

  export default {
    name: "placeholder-editor",
    mixins: [i18n, propertyMixin],
    props: {
      designer: Object,
      selectedWidget: Object,
      optionModel: Object,
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// placeholder-editor.vue?7bc176a0